import type { ReactNode } from 'react'

import { NavItemSwitch } from '@/shared/access'

import { courseCatalogNav, courseCatalogVisibilityApi, isCourseCatalogVisible } from './course-catalog/paths'
import { CourseReachProvider } from './courses/CourseReachProvider'

/**
 * Catalog's app-wide context: course names linked only for a viewer who may open them, and
 * "Courses" in the nav only while the viewer's catalog opens, the site's and their organization's
 * switches both on.
 */
export function CatalogProvider(props: { readonly children: ReactNode }) {
  return (
    <CourseReachProvider>
      <NavItemSwitch item={courseCatalogNav} path={courseCatalogVisibilityApi} isOn={isCourseCatalogVisible}>
        {props.children}
      </NavItemSwitch>
    </CourseReachProvider>
  )
}
